<script>
import { Vue, Component, Prop } from "vue-property-decorator";
import {translations} from '@/mixins'

@Component(
  {mixins: [ translations]}
)
export default class CursorPagination extends Vue {
  @Prop({ default: null, type: [String, Number, null] }) prevCursor
  @Prop({ default: null, type: [String, Number, null] }) nextCursor
  @Prop({ default: false, type: Boolean }) loading;
  @Prop({ default: "Prev", type: String }) prevLabel;
  @Prop({ default: "Next", type: String }) nextLabel;

  onPaginate(cursor) {
    this.$emit("paginate", cursor);
  }
}
</script>

<template>
  <div class="new_pagination">
    <b-button
      :disabled="!prevCursor || loading"
      @click="onPaginate(prevCursor)"
      data-testid="prev-btn"
    >
      {{ translate(prevLabel) }}
    </b-button>
    <b-button
      :disabled="!nextCursor || loading"
      @click="onPaginate(nextCursor)"
      data-testid="next-btn"
    >
      {{ translate(nextLabel) }}
    </b-button>
  </div>
</template>

